<template>
  <!-- Navbar -->
  <nav id="bodynavbar" class="main-header navbar navbar-expand navbar-dark">
    <!-- Left navbar links -->
    <ul class="navbar-nav">
      <li class="nav-item">
        <a class="nav-link" data-widget="pushmenu" href="#" role="button"
          ><i class="fas fa-bars"></i
        ></a>
      </li>
    </ul>

    <!-- Right navbar links -->
    <ul class="navbar-nav ml-auto">
 
      <li class="nav-item dropdown">
        <select v-model="selected" @change="seleccionarPeriodo()"  class="form-control form-xs badge-danger text-sm">
          <option disabled value="">Seleccionar Periodo</option> 
          <option v-for="periodo in periodos" :key="periodo">     
            {{periodo.periodo}}
          </option>
        </select>
      </li>


      <!-- <li class="nav-item">
        <a
          class="nav-link"
          @click="modoClaro()"
          v-if="isHidden"
          v-on:click="isHidden = false"
          role="button"
        >
          <i class="fas fa-sun icon-sun"></i>
        </a>
      </li>

      <li class="nav-item">
        <a
          class="nav-link"
          @click="modoOscuro()"
          v-if="!isHidden"
          v-on:click="isHidden = true"
          role="button"
        >
          <i class="fas fa-moon icon-moon"></i>
        </a>
      </li> -->

      <li class="nav-item">
        <a class="nav-link" data-widget="fullscreen" href="#" role="button">
          <i class="fas fa-expand-arrows-alt"></i>
        </a>
      </li>

      <li class="nav-item">
        <a class="nav-link" v-on:click="salir()" role="button">
          <i class="fas fa-sign-out-alt"></i>
          <label for="">Cerrar Sesión</label>
        </a>
      </li>
    </ul>
  </nav>
  <!-- /.navbar -->
</template>


<script>
export default {
  data: () => {
    return {
      isHidden: false,
      periodos:[],
      selected: ""
    };
  },

  methods: {

    async periodoActivo(){
      try{
        let response = await this.axios.get('/Responsabilidad/buscarPeriodoActivo')
        var jsonResponse = response.data.entidad[0].resultado
        this.periodos = JSON.parse(jsonResponse)
        console.log(response)
      }catch(error){
        console.log(error);
      }
    },
    seleccionarPeriodo(){
      localStorage.setItem('periodo', this.selected);
    },
    modoOscuro() {
      var item5 = document.getElementById("bodynavbar");
      item5.classList.remove("navbar-light");

      var item2 = document.getElementById("bodysidebar");
      item2.classList.remove("sidebar-light-info");

      localStorage.color = "dark-mode";
      localStorage.colorsidebar = "sidebar-dark-white";
      localStorage.colornav = "navbar-dark";

      var fondo = localStorage.getItem("color");
      var fondosidebar = localStorage.getItem("colorsidebar");
      var fondonav = localStorage.getItem("colornav");

      var item = document.getElementById("bodyprincipal");
      item.className += " " + fondo;
      var item2 = document.getElementById("bodysidebar");
      item2.className += " " + fondosidebar;
      var item28 = document.getElementById("bodynavbar");
      item28.className += " " + fondonav;

      this.isHidden = false;
    },
    modoClaro() {
      var item = document.getElementById("bodyprincipal");
      item.classList.remove("dark-mode");

      var item2 = document.getElementById("bodysidebar");
      item2.classList.remove("sidebar-dark-white");

      var item26 = document.getElementById("bodynavbar");
      item26.classList.remove("navbar-dark");

      var item4 = document.getElementById("bodysidebar");
      item4.className += " " + "sidebar-light-info";

      var item39 = document.getElementById("bodynavbar");
      item39.className += " " + "navbar-light";

      localStorage.removeItem("color");
      localStorage.removeItem("colorsidebar");
      localStorage.removeItem("colornav");
    },
    salir() {
      this.$router.push("/");
      sessionStorage.clear();
      localStorage.clear();
      this.modoClaro();
    },
    Color() {
      alert(hola);
    },
  },
  mounted() {
    this.periodoActivo();
    if (localStorage.getItem("color") === "dark-mode") {
      var fondo = localStorage.getItem("color");
      var item = document.getElementById("bodyprincipal");
      item.className += " " + fondo;
    }

    if (localStorage.getItem("colorsidebar") === "sidebar-dark-white") {
      var fondo2 = localStorage.getItem("colorsidebar");
      var item3 = document.getElementById("bodysidebar");
      item3.classList.remove("sidebar-light-info");
      var item2 = document.getElementById("bodysidebar");
      item2.className += " " + fondo2;
    }

    if (localStorage.getItem("colornav") === "navbar-dark") {
      var fondo21 = localStorage.getItem("colornav");
      var item32 = document.getElementById("bodynavbar");
      item32.classList.remove("navbar-light");
      var item24 = document.getElementById("bodynavbar");
      item24.className += " " + fondo21;
    }
  },
};
</script>

<style scoped>

.main-header{
  background-color: #324452;
}


.icon-sun {
  color: #ffd000;
}

.icon-moon {
  color: #919191;
}
</style>


